<div class="profile-info-container">
    <ion-icon name="person-circle-outline"></ion-icon>
    <span class="username">
        {{ userFullName | async }}
    </span>
</div>
<mat-nav-list>
    <a
        mat-list-item
        *ngFor="let navItem of tabsLabelRoutesMap"
        [routerLink]="navItem.route"
        routerLinkActive="active-router"
        (click)="sideNavItemClickedEventHandler($event)"
        >{{ navItem.label }}</a
    >
</mat-nav-list>
